import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import HSOCMerchCard from './HSOCMerchCard';
import HSOCMerchCardColumnsLayoutUI from './HSOCMerchCardColumnsLayoutUI';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HSOCMerchCardsContainer = () => {
  const trackingData = {
    trackingSource: 'merch-card',
    screen: 'default'
  };
  return /*#__PURE__*/_jsxs(HSOCMerchCardColumnsLayoutUI, {
    children: [/*#__PURE__*/_jsx(HSOCMerchCard, {
      apiName: Products.CORE_SEATS_STARTER_HSOC,
      columnStart: 1,
      trackingData: trackingData
    }), /*#__PURE__*/_jsx(HSOCMerchCard, {
      apiName: Products.CORE_SEATS_PROFESSIONAL_HSOC,
      columnStart: 2,
      trackingData: trackingData,
      Badge: /*#__PURE__*/_jsx(Flex, {
        position: "absolute",
        insetInlineStart: "0",
        insetInlineEnd: "0",
        insetBlockStart: "0",
        insetBlockEnd: "0",
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(View, {
          paddingInline: "300",
          borderRadius: "full",
          backgroundColor: "fill-brand-default",
          zIndex: "1",
          children: /*#__PURE__*/_jsx(Text, {
            as: "small",
            color: "text-primary-default",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.merchCardsV2.badges.RECOMMENDED"
            })
          })
        })
      }),
      cardStyles: {
        borderColor: 'border-brand-default',
        boxShadow: '400',
        customBoxShadow: {
          offsetX: '0px',
          offsetY: '0px',
          blur: '25px',
          spread: '-7px',
          color: 'fill-brand-default'
        }
      }
    }), /*#__PURE__*/_jsx(HSOCMerchCard, {
      apiName: Products.CORE_SEATS_ENTERPRISE_HSOC,
      columnStart: 3,
      trackingData: trackingData
    })]
  });
};
export default HSOCMerchCardsContainer;